
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './notfoundpage.scss';






const Pnotfoundpage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id68abd8cd60a29c1eab0fc424" >

      <div id="iwt62" className="">
      
      <div id="icxk" className="">
      
      <div id="iin8q" className="">
      
      <div id="ify1g" className="">
      
      <img
        className=""
        id="ip8xoj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimermwqde.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i95gii" className="">
      
        <a
          target=""
          className=""
          id="ipz0pg"
          href={`/`}
        >
          
    <div id="i2vvpe" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwg0nn"
          href={`/menu`}
        >
          
    <div id="idbyah" className="">
    <>Menú</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv95sw"
          href={`/contact`}
        >
          
    <div id="icq2ek" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="ilsg2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb9whf2w.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ith9m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimb9wcuyg.png"
        alt="undefined"
      />
      
      <div id="i1xxv" className="">
      
      <div id="inwavh" className="">
      
      <div className="" id="iybdaj">
        <>404</>
      </div>
      
      <div className="" id="ie1an">
        <>¡Mamma mia! Esta página no existe...</>
      </div>
      
      <div className="" id="igzbv">
        <>La página que estás buscando no está en nuestro menú.</>
      </div>
      
      </div>
      
      <div id="iz083u" className="">
      
        <a
          target=""
          className=""
          id="irhnqj"
          href={`/`}
        >
          
    <div id="iptqks" className="">
    <>Volver A Inicio</>
      <br className="" id="" />
      
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pnotfoundpage);
  